import Vue from 'vue';
import Vuex from 'vuex';
import data from '../data/data.json';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mapData: data,
    locationData: null,
    selectedPin: null,
    sideBarOpen: false,
    filterToggled: true,
    isMobile: false,
    tempFilterChangePostLoad: false,
    sidebarLocations: [],
    zoomLevel: 6,
    resetZoom: 6,
    centerTo: null,
    locationId: null,
    mainMap: null,
    mainPins: null,
    initialMessageOpen: true,
    thePinsPath: null,
    thePublicPath: process.env.BASE_URL,
    initialMatchedItems: [],
    categoryList: [
      { value: 'retirement', text: 'Rethinking retirement' },
      { value: 'housing', text: 'Tackling the housing crisis' },
      { value: 'sme', text: 'SME investment' },
      { value: 'future', text: 'Future-proofing society' },
      { value: 'urban', text: 'Urban regeneration' },
      { value: 'climate', text: 'Addressing climate change' },
    ],
    categories: [],
    mapStyle: [
      {
        featureType: 'administrative',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#444444',
          },
        ],
      },
      {
        featureType: 'administrative.neighborhood',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape.man_made',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape.natural',
        elementType: 'all',
        stylers: [
          {
            visibility: 'simplified',
          },
          {
            color: '#ffffff',
          },
        ],
      },
      {
        featureType: 'landscape.natural',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape.natural.landcover',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape.natural.terrain',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'all',
        stylers: [
          {
            visibility: 'on',
          },
          {
            color: '#bbd143',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'simplified',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 45,
          },
          {
            visibility: 'on',
          },
          {
            color: '#ffeea3',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'all',
        stylers: [
          {
            color: '##000000',
          },
          {
            visibility: 'on',
          },
        ],
      },
    ],
  },
  mutations: {
    sideBarOpen(state, payload) {
      state.sideBarOpen = true;
      state.locationId = payload;
    },
    filterToggled(state, payload) {
      state.filterToggled = payload;
    },
    isMobile(state, payload) {
      state.isMobile = payload;
    },
    tempFilterChangePostLoad(state, payload) {
      state.tempFilterChangePostLoad = payload;
    },
    initialMessageOpen(state, payload) {
      state.initialMessageOpen = payload;
    },
    closeSidebar(state) {
      state.sideBarOpen = false;
      state.locationId = null;
    },
    initialCenterTo(state, payload) {
      state.centerTo = payload;
    },
    thePinsPath(state, payload) {
      state.thePinsPath = payload;
    },
    updateCategories(state, payload) {
      state.categories = [...payload];
    },
    updateSidebarLocations(state, payload) {
      state.sidebarLocations = [...payload];
      // console.log('sidebarLocations', payload);
    },
    updateZoomLevel(state, payload) {
      state.zoomLevel = payload;
    },
    updateCenterTo(state, payload) {
      state.centerTo = payload;
    },
    updateSelectedPin(state, payload) {
      state.selectedPin = payload;
    },
    theMap(state, payload) {
      state.mainMap = payload;
    },
    thePins(state, payload) {
      state.mainPins = payload;
      // console.log('mainPins', payload);
    },
  },
  actions: {
  },
  modules: {
  },
});
